<template>
  <div class="ps-table-wrap eval-pivot-table">
    <ve-table
      :fixed-header="true"
      :columns="columns"
      :max-height="'calc(100vh - 450px)'"
      :table-data="tableData"
      :border-around="true"
    />
    <div v-if="!isLoading && !rows.length" class="table-empty-state">
      <span>No data found</span>
    </div>
  </div>
</template>

<script>
import { VeTable } from 'vue-easytable';

export default {
  components: { VeTable },
  props: {
    dates: {
      type: Array,
      default: () => [],
    },
    rows: {
      type: Array,
      default: () => [],
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    columns() {
      const cols = [
        {
          field: '_label',
          key: '_label',
          title: 'Result',
          width: 200,
          align: 'left',
          fixed: 'left',
          renderBodyCell: ({ row }) => (
            <span class="metric-cell">{row._label}</span>
          ),
        },
      ];

      this.dates.forEach(date => {
        cols.push({
          field: date,
          key: date,
          title: date,
          width: 100,
          align: 'center',
          renderBodyCell: ({ row }) => {
            const val = row[date];
            const isClickable = val > 0 && row._key !== 'total';
            return (
              <span
                class={{
                  'data-cell': true,
                  'data-cell-bold': row._key === 'total',
                  'data-cell-clickable': isClickable,
                }}
                onClick={() =>
                  isClickable && this.handleCellClick(row, date, val)
                }
              >
                {val != null ? val : ''}
              </span>
            );
          },
        });
      });

      return cols;
    },
    tableData() {
      if (!this.rows.length) {
        return [];
      }
      return this.rows.map(row => {
        const obj = { _key: row.key, _label: row.label };
        this.dates.forEach((date, i) => {
          obj[date] = row.values[i];
        });
        return obj;
      });
    },
  },
  methods: {
    handleCellClick(row, date, val) {
      this.$emit('cell-click', {
        rowKey: row._key,
        rowLabel: row._label,
        date,
        count: val,
      });
    },
  },
};
</script>

<style lang="scss">
.eval-pivot-table {
  .ve-table {
    padding-bottom: 0 !important;
  }
}
</style>

<style scoped lang="scss">
@import '~dashboard/assets/scss/widgets/_ps_table.scss';

.metric-cell {
  font-weight: 500;
  color: var(--s-800);
}

.data-cell {
  color: var(--s-700);

  &.data-cell-bold {
    font-weight: 600;
    color: var(--s-900);
  }

  &.data-cell-clickable {
    cursor: pointer;
    color: var(--w-500);
    font-weight: 500;
    text-decoration: underline;

    &:hover {
      color: var(--w-700);
    }
  }
}

.table-empty-state {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: var(--space-large);
  color: var(--s-400);
  font-size: var(--font-size-small);
}
</style>
